import { render } from "./WhyChooseUs.vue?vue&type=template&id=4034cc87&scoped=true"
import script from "./WhyChooseUs.vue?vue&type=script&lang=js"
export * from "./WhyChooseUs.vue?vue&type=script&lang=js"

import "./WhyChooseUs.vue?vue&type=style&index=0&id=4034cc87&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4034cc87"]])

export default __exports__